import Box from '@ramsey-design-system/box';
import { ReactElement, ReactNode } from 'react';
import { useWizard } from 'react-use-wizard';
import ProgressBar from '@ramsey-design-system/progress-bar';
import { BackChevron } from '../BackChevron';

interface Props {
  children: ReactNode;
}

function StepWrapper({ children }: Readonly<Props>): ReactElement {
  const { activeStep, stepCount } = useWizard();

  return (
    <div data-testid={'step-wrapper'} className="flex justify-center">
      <Box className="w-[345px] sm:!w-[418px]" hasBorder={true} padding="lg">
        <div className="flex justify-between items-center mb-4">
          <BackChevron dataTestID="tax_referral_form_back_button" />
          <ProgressBar
            value={((activeStep + 1.0) / (stepCount + 0.5)) * 100}
            className={'ml-4 mr-4'}
            size={'large'}
          />
          <div className="min-w-1.75 min-h-1.75" />
        </div>
        {children}
      </Box>
    </div>
  );
}

export { StepWrapper };
